/* Privacy-gated Shopify custom events. Never reads email values or transmits URLs.
   Accepted means native form acceptance, NOT a proven new marketing subscriber. */
(() => {
  'use strict';
  const S = window.Shopify;
  if (!S || S.designMode || !S.theme || S.theme.role !== 'main' || new URLSearchParams(location.search).has('preview_theme_id')) return;
  const key = 'mrp_signup_pending_v1';
  const allowed = () => Boolean(S.customerPrivacy && typeof S.customerPrivacy.analyticsProcessingAllowed === 'function' && S.customerPrivacy.analyticsProcessingAllowed());
  const clear = () => { try { sessionStorage.removeItem(key); } catch (_) {} };
  const emit = (name, data) => {
    if (!allowed() || !S.analytics || typeof S.analytics.publish !== 'function') return;
    try { Promise.resolve(S.analytics.publish(name, data)).catch(() => {}); } catch (_) {}
  };
  const group = (form) => {
    const tags = (form.querySelector('input[name="contact[tags]"]')?.value || '').split(',');
    if (tags.includes('book-updates') || tags.includes('the-lost-journals')) return 'books';
    if (tags.includes('fieldwear-updates')) return 'fieldwear';
    if (tags.includes('development-record')) return 'equipment';
    return 'field_notes';
  };
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.querySelector('input[name="form_type"]')?.value !== 'customer' || !allowed()) return;
    const formId = form.id;
    if (!formId) return;
    const rawPageType = (document.getElementById('MainContent')?.dataset.template || '').split('.')[0];
    const pageType = ['index', 'page', 'product', 'article', 'blog', 'collection'].includes(rawPageType) ? rawPageType : 'other';
    const data = { form_id: formId, interest_group: group(form), page_type: pageType };
    try { sessionStorage.setItem(key, JSON.stringify({ data, at: Date.now() })); } catch (_) {}
    emit('mrp_newsletter_submit', data);
  }, true);
  const accepted = () => {
    if (!allowed()) { clear(); return; }
    let pending;
    try { pending = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (_) { clear(); return; }
    if (!pending) return;
    if (!pending.data || !Number.isFinite(pending.at) || Date.now() - pending.at > 1800000 || pending.at > Date.now()) { clear(); return; }
    const form = document.getElementById(pending.data.form_id);
    if (!form || !form.querySelector('[data-mrp-signup-accepted="true"], .mp-lj__success')) return;
    clear();
    emit('mrp_newsletter_signup_accepted', pending.data);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', accepted, { once: true });
  else accepted();
  document.addEventListener('visitorConsentCollected', () => { if (!allowed()) clear(); });
})();
